<ion-header class="ion-no-border">
  <ion-item lines="full">
    <ion-label>
      <h6 class="bold">Settings</h6>
    </ion-label>

    <ion-button (click)="closeSidebar.emit()" tooltip="Close" aria-label="Close">
      <ion-icon src="/assets/icons/24px/close.svg" slot="icon-only"> </ion-icon>
    </ion-button>
  </ion-item>
</ion-header>
<!------------------------- EQUIPMENT SETTINGS START            ------------------------->
<ion-list lines="none">
  <ion-item class="input-small" lines="none" counter="false">
    <sc-avatar [photoURL]="(user$ | async)?.photoURL"></sc-avatar>

    <ion-input
      [(ngModel)]="name"
      (keyup.enter)="saveName()"
      name="name"
      type="text"
      scAutoFocus
      placeholder="Your Name (Pronouns)"
      minlength="3"
      maxlength="50">
    </ion-input>

    <ion-button aria-label="Save Name" (click)="saveName()" tooltip="Save" fill="clear" class="primary save-button">
      Save
    </ion-button>
  </ion-item>

  <sc-equipment-list ui="name-menu"> </sc-equipment-list>

  <!-- <ion-item>
    <ion-icon src="/assets/icons/24px/magic-2.svg" slot="start"> </ion-icon>

    <ion-label class="pointer">
      Background
      <p *ngIf="!noWASM && (session$ | async).videoEnabled === false" class="ion-text-wrap">Change your background</p>
      <p *ngIf="noWASM && (session$ | async).videoEnabled === false" class="ion-text-wrap">Not available in your browser</p>
      <p *ngIf="(session$ | async).videoEnabled" class="ion-text-wrap">Only available in Audio sessions</p>
    </ion-label>

    <ion-select
      class="video-filter-select"
      interface="popover"
      [value]="currentVideoFilter"
      [disabled]="noWASM || (session$ | async).videoEnabled"
      (ionChange)="selectVideoFilter($event)">
      <ion-select-option *ngFor="let filter of videoFilters" [value]="filter">{{ filter.name }}</ion-select-option>
    </ion-select>
  </ion-item> -->
  <!------------------------- EQUIPMENT SETTINGS START              ------------------------->
  <ion-item
    *ngIf="
      session$?.value.confType !== 'daily' &&
      (role$ | async) >= roleLimits.MICROPHONE_UPDATE &&
      isVoiceConf &&
      !backstage
    ">
    <ion-icon src="/assets/icons/24px/dolby-voice.svg" slot="start"> </ion-icon>

    <ion-label class="pointer" (click)="openDolbyInfoMenu($event)">
      Noise Reduction
      <p class="ion-text-wrap">Does not impact recording quality.</p>
      <a href="#" tabindex="-1"></a>
    </ion-label>

    <ion-toggle
      *ngIf="noiseReduction !== undefined"
      [checked]="noiseReduction"
      (ionChange)="toggleNoiseReduction($event)"
      mode="ios"
      slot="end">
    </ion-toggle>
  </ion-item>

  <div
    class="recording-quality-container"
    [tooltip]="
      recordingQuality && (role$ | async) < roles.SHOW_MANAGER ? 'Recording Quality is Controlled by Show Manager' : ''
    ">
    <ion-item *ngIf="(plan$ | async)?.videoUHD || (role$ | async) > roles.GUEST">
      <ion-icon src="/assets/icons/24px/quality-2.svg" slot="start"> </ion-icon>
      <ion-label class="pointer">
        Max<span *ngIf="(plan$ | async)?.videoUHD">imize Recording</span> Quality
        <sc-learn-more topic="qualityStandards" class="inline"></sc-learn-more>
      </ion-label>
      <ion-button
        *ngIf="!(plan$ | async)?.videoUHD"
        [upgrade]="!(plan$ | async)?.videoUHD"
        [class.disabled]="!(plan$ | async)?.videoUHD"
        tooltip="Upgrade To Unlock"
        (click)="window.open('/account/subscription', '_blank')"
        oncontextmenu="false"
        class="primary upgrade"
        expand="block">
        Enable 4K!
      </ion-button>
      <ion-toggle
        *ngIf="(plan$ | async)?.videoUHD"
        [checked]="recordingQuality"
        (ionChange)="toggleSessionRecordingQuality($event)"
        [attr.aria-label]="'Recording Quality ' + recordingQuality ? 'Enabled' : 'Disabled'"
        [disabled]="(recording$ | async) || (recordingQuality && (role$ | async) < roles.SHOW_MANAGER)"
        mode="ios"
        slot="end">
      </ion-toggle>
    </ion-item>
  </div>

  <div
    *ngIf="!backstage && !isVoiceConf && (role$ | async) >= roleLimits.MICROPHONE_UPDATE"
    class="echo-cancellation-container"
    [tooltip]="
      sessionEchoCancellation && (role$ | async) < roles.SHOW_MANAGER
        ? 'Echo Cancellation is Controlled by Show Manager'
        : ''
    ">
    <ion-item aria-label="Echo Cancellation">
      <ion-icon
        [src]="
          echoCancellation ? '/assets/icons/24px/echo-cancellation.svg' : '/assets/icons/24px/echo-cancellation-off.svg'
        "
        slot="start">
      </ion-icon>

      <ion-label class="pointer">
        Echo Cancellation
        <p class="ion-text-wrap">
          Toggle on if you are not wearing headphones or are experiencing echo.
          <sc-learn-more topic="echoCancellation" class="inline"></sc-learn-more>
        </p>
      </ion-label>

      <ion-toggle
        *ngIf="echoCancellation !== undefined"
        [checked]="echoCancellation"
        (ionChange)="toggleEchoCancellation($event)"
        [attr.aria-label]="'Echo Cancellation ' + echoCancellation ? 'Enabled' : 'Disabled'"
        [disabled]="(recording$ | async) || (sessionEchoCancellation && (role$ | async) < roles.SHOW_MANAGER)"
        mode="ios"
        slot="end">
      </ion-toggle>
    </ion-item>

    <ion-item class="checkbox-container" *ngIf="(role$ | async) >= roles.SHOW_MANAGER">
      <ion-checkbox
        mode="md"
        [checked]="sessionEchoCancellation"
        (ionChange)="toggleSessionEchoCancellation($event)"
        [disabled]="recording$ | async"
        aria-label="change echo cancellation for all participants"></ion-checkbox>
      <ion-label>Change for all participants</ion-label>
    </ion-item>
  </div>

  <ion-item>
    <ion-icon src="/assets/icons/24px/hide-past-sessions.svg" slot="start"> </ion-icon>

    <ion-label class="pointer">
      Hide Incoming Video
      <p class="ion-text-wrap">
        Improves performance. <sc-learn-more topic="hideIncVideo" class="inline"></sc-learn-more>
      </p>
    </ion-label>

    <ion-toggle
      *ngIf="hideIncomingVideo !== undefined"
      [checked]="hideIncomingVideo"
      (ionChange)="toggleHideIncomingVideo($event)"
      mode="ios"
      slot="end">
    </ion-toggle>
  </ion-item>

  <ion-item *ngIf="!backstage">
    <ion-icon src="/assets/icons/24px/hide-self.svg" slot="start"> </ion-icon>

    <ion-label>
      Hide Yourself
      <p class="ion-text-wrap">Others will still see you.</p>
      <a href="#" tabindex="-1"></a>
    </ion-label>

    <ion-toggle
      [checked]="hideSelf"
      (ionChange)="toggleHideSelf($event)"
      mode="ios"
      slot="end">
    </ion-toggle>
  </ion-item>
</ion-list>
<!------------------------- EQUIPMENT SETTINGS END              ------------------------->

<!------------------------- SESSION/RECORDINGS SETTINGS START   ------------------------->
<ion-list lines="none">
  <h6 class="bold">Recording Format<sc-learn-more topic="createRecordingSession" class="inline"></sc-learn-more></h6>
  <div id="session-type">
    <p class="micro-bold ion-text-center">
      <ion-icon
        [src]="
          session$.value.videoEnabled ? 'assets/icons/32px/video-bold.svg' : 'assets/icons/32px/mic-bold.svg'
        "></ion-icon>
      {{ session$.value.videoEnabled ? 'Video &' : '' }} Audio
    </p>

    <p class="micro-regular ion-text-center">
      {{
        session$.value.videoEnabled
          ? 'All participants on stage will have their audio and video recorded. Schedule a new session to change to Audio Only.'
          : 'All participants on stage will only have their audio recorded. Schedule a new session to change to Video & Audio.'
      }}
    </p>
  </div>
  <div class="windows-override-container" *ngIf="participantOnWindows && (role$ | async) >= roles.SHOW_MANAGER">
    <ion-item>
      <ion-label class="pointer">
        4K Recording on Windows<br /><span class="grey">(not recommended)</span>
        <p>
          Windows limits the recording bitrate in web browsers, and 4K typically looks worse than 1080p. Turn this on at
          your risk!
        </p>
        <!-- <sc-learn-more topic="windows4K" class="inline"></sc-learn-more> -->
      </ion-label>
      <ion-toggle
        [checked]="windows4KOverride"
        (ionChange)="toggleWindows4KOverride($event)"
        [disabled]="recording$ | async"
        [attr.aria-label]="'Enable 4K Recording on Windows'"
        mode="ios"
        slot="end">
      </ion-toggle>
    </ion-item>
  </div>
</ion-list>
<!------------------------- SESSION/RECORDINGS SETTINGS END     ------------------------->

<!------------------------- CONFERENCE SETTINGS START           ------------------------->
<ion-list *ngIf="session$?.value.confType !== 'daily'" lines="none">
  <h6 class="bold" *ngIf="(role$ | async) >= roleLimits.SHOW_UPDATE">
    Conference Type <sc-learn-more topic="confTypes" class="inline"></sc-learn-more>
  </h6>
  <div
    *ngIf="(role$ | async) >= roleLimits.SHOW_UPDATE"
    class="conference-type"
    [tooltip]="(recording$ | async) ? 'Unable change conference type while recording' : ''"
    [tooltipOptions]="{ delay: [0, 0] }">
    <button [disabled]="recording$ | async" (click)="setVoiceConf(ConfTypes.CLASSIC)" [class.active]="!isVoiceConf">
      <ion-icon src="assets/icons/16px/recordings.svg"></ion-icon>
      <div class="info">
        <h6 class="bold">Classic Conference</h6>
        <ul>
          <li>Low Latency Connection</li>
          <li>High Audio Quality <span>(128kbps | 48khz)</span></li>
          <li>Mixed Cloud Backups</li>
        </ul>
      </div>
    </button>
    <button [disabled]="recording$ | async" (click)="setVoiceConf(ConfTypes.VOICE)" [class.active]="isVoiceConf">
      <ion-icon src="assets/icons/24px/dolby-voice-2.svg"></ion-icon>
      <div class="info">
        <h6 class="bold">Dolby Voice Conference</h6>
        <ul>
          <li>Noise Reduction</li>
          <li>Standard Audio Quality <span>(12-16kbps | 48khz)</span></li>
          <li>Individual Track Cloud Backups</li>
        </ul>
      </div>
    </button>
  </div>

  <h6 class="bold">Toolbar Layout</h6>
  <p class="ion-text-wrap body-small">Long hold on a toolbar item to customize your layout.</p>
  <div class="reset-toolbar-button-container">
    <ion-item class="checkbox-container">
      <ion-checkbox
        mode="md"
        [checked]="allowMultipleSidebars"
        (ionChange)="toggleAllowMultipleSidebars($event)"
        aria-label="allow multiple sidebars to be open at the same time"></ion-checkbox>
      <ion-label>Allow opening multiple sidebars</ion-label>
    </ion-item>
    <ion-button (click)="resetToolbarLayout()" class="text" size="small">Reset Toolbar Layout</ion-button>
  </div>
</ion-list>
<!------------------------- CONFERENCE SETTINGS END             ------------------------->

<input
  #imageFile
  type="file"
  aria-label="Background Image Input"
  accept="image/png,image/jpeg,image/jpg"
  (change)="imageFileInput($event)"
  style="display: none" />
